import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { AutosizeModule } from 'ngx-autosize';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { CollapsiblePatientNoteComponent } from './collapsible-patient-note.component';

@NgModule({
  declarations: [CollapsiblePatientNoteComponent],
  imports: [
    CommonModule,
    CollapseModule,
    NgxBootstrapIconsModule,
    NgxSliderModule,
    ReactiveFormsModule,
    AutosizeModule,
    AccordionModule,
  ],
  exports: [CollapsiblePatientNoteComponent],
})
export class CollapsiblePatientNoteModule {}
